module.exports = __webpack_public_path__ + "img/default.3b8fc997.jpg";